<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="400px"
    persistent
    style="position: absolute; bottom: 0"
  >
    <v-card>
      <v-card-actions class="text-right">
        <v-btn color="blue darken-1" text @click="closeDialog()">Close</v-btn>
      </v-card-actions>
      <v-card-text>
        <div v-for="element in allOutputDocumentActivity" :key="element.id">
          <v-container v-if="element.user_route_assignments.length < 1">
            <h3 class="outline mb-2 indigo--text">{{ element.document.name }}</h3>
            <span
              class="mb-2"
            >Attached in {{ element.routes[0].name }} route
            </span>
            <br />
            <span>- <i> Uploaded by {{ element.routes[0].user.first_name }} {{ element.routes[0].user.last_name }}</i></span>
          </v-container>
          <v-container v-else-if="element.routes.length < 1">
            <h3 class="outline mb-2 indigo--text">{{ element.document.name }}</h3>
            <span
              class="mb-2"
            >Attached in {{ element.user_route_assignments[0].name }} sub-route
            </span>
            <br />
            <span>- <i> Uploaded by {{ element.user_route_assignments[0].user.first_name }} {{ element.user_route_assignments[0].user.last_name }}</i></span>
          </v-container>
          <v-divider></v-divider>
        </div>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "OutputDocumentActivity",
  props: {
    dialog: Boolean,
    transactionId: String
  },
  data() {
    return {
      sample: [
        {
          id: 1,
          name: "Subjects of Ymir",
          route: "Good Route",
          user: "John Doe",
        },
        {
          id: 2,
          name: "Subjects of Ymir",
          route: "Good Route",
          user: "John Doe",
        },
        {
          id: 3,
          name: "Subjects of Ymir",
          route: "Good Route",
          user: "John Doe",
        },
        {
          id: 4,
          name: "Subjects of Ymir",
          route: "Good Route",
          user: "John Doe",
        },
        {
          id: 5,
          name: "Subjects of Ymir",
          route: "Good Route",
          user: "John Doe",
        },
      ],
    };
  },
  methods: {
    ...mapActions(['fetchOutputDocumentActivity']),
    closeDialog() {
      this.$emit('closeDialog', false);
    }
  },
  computed: mapGetters(['allOutputDocumentActivity']),
  watch: {
    dialog: function () {
      if(this.dialog) {
        this.fetchOutputDocumentActivity(this.transactionId);
      }
    }
  }
};
</script>

<style>
</style>